export class AppConfig {

    // Autres
    Google_Places_Api_Key = "AIzaSyBjYMggqBZq8gH5PCtUhEBJlcv_k2B-bxM" ;

    

    mode = "0" // Carrefour
   // mode = "1" // Driver

    // Clef de Mapping

    MapBoxKey = "pk.eyJ1IjoiY2NoZXp2b3VzIiwiYSI6ImNsMG50eThlZzBtaGMzam50ajRzMTUwZ3cifQ.ibOI_dgWSH67H3m2a3uMNg"

    xapikey = "xapikey"
    xapisecret = "xapisecret";

    TasksAnnounced = [
      {
        "createdBy": {
          "firstName": "John",
          "lastName": "Doe",
          "_id": "507f191e810c19729de860ea",
          "id": "507f191e810c19729de860ea",
          "externalId": "string"
        },
        "__v": 0,
        "_id": "string",
        "initialSequence": 0,
        "trackingId": "abcdef-123456-4abc-acbacbfcabcfbcbfbacbfab",
        "extTrackId": "ext-12345",
        "type": "delivery",
        "taskId": "my-task-id",
        "taskReference": "task-ref-001-d",
        "progress": "ANNOUNCED",
        "status": "PICKED_UP",
        "client": "507f191e810c19729de860ea",
        "hub": "507f191e810c19729de860ea",
        "hubName": "My Warehouse",
        "associatedName": "Lumikko Oyj",
        "associated": "5c3c63c23c32c30cb3cc1234c",
        "dependency": "507f191e810c19729de860ea",
        "hasDependency": "507f191e810c19729de860ea",
        "round": "R01",
        "archived": false,
        "actualTime": {
          "arrive": {
            "when": "2019-03-24T12:34:56.123Z",
            "location": {
              "type": "Point",
              "geometry": [
                0
              ]
            },
            "forced": false,
            "isCorrectAddress": false
          }
        },
        "order": "5c98f80a6b3dc61664c05cbf",
        "paymentType": "CCOD",
        "platform": "5c98f80a6b3dc61664c05cbf",
        "platformName": "Cortedal SYS, Oy",
        "endpoint": "5c3c645e3b37f30b3fc0240f",
        "errorLocation": {
          "addressLines": [
            "string"
          ],
          "cleanScore": 0,
          "geocodeScore": 98,
          "location": {
            "type": "Point",
            "geometry": [
              0
            ]
          }
        },
        "customerCalls": [
          {
            "when": "2019-03-13T12:34:56.012Z",
            "by": "string"
          }
        ],
        "issues": [
          {
            "type": "GEOCODING",
            "code": 0,
            "line": 0,
            "error": "string"
          }
        ],
        "notifications": [
          {
            "notifiationId": "string",
            "sentDate": "2019-12-23T12:34:56.123Z",
            "by": {
              "firstName": "John",
              "lastName": "Doe",
              "email": "john.doe@example.3w",
              "phoneNumber": "32123123123",
              "picture": "/some/folder/image/c1235b6a253cd12d3",
              "reference": {
                "name": "self",
                "value": "john.doe@example.3w"
              },
              "_id": "507f191e810c19729de860ea",
              "id": "507f191e810c19729de860ea",
              "externalId": "string"
            }
          }
        ],
        "notificationSettings": {
          "sms": false,
          "email": false
        },
        "optimizationGroup": "string",
        "optimizationCount": 0,
        "replanned": false,
        "sourceHash": "string",
        "updated": "2019-03-24T12:34:56.123Z",
        "when": "2019-03-24T12:34:56.123Z",
        "targetFlux": "56fe250f1eb3571100bb081c_MORNING_57454b1556950a11005189fa_2017-11-15",
        "skills": [
          "speaks_french"
        ],
        "roundName": "R03",
        "roundColor": "#FFCC0D",
        "products": [
          {
            "productId": "001234",
            "name": "CHEESE",
            "description": "Goat cheese pack, 400gr",
            "type": "food",
            "barcode": "11231212121",
            "quantity": 3,
            "unitPrice": 13.95,
            "isSubstitution": false,
            "quantityRejected": 0,
            "rejectedReason": {
              "_id": "507f191e810c19729de860ea",
              "name": "damaged"
            }
          }
        ],
        "hasRejectedProducts": false,
        "activity": "classic",
        "sequence": 1,
        "id": "5c98f80a6b3dc61664c05cbb",
        "flux": "5c3c63c23c32c30cb3cc1234c",
        "collectedAmount": 10.2,
        "closureDate": "2019-03-25T15:50:50.123Z",
        "by": "5c3c63c23c32c30cb3cc1234c",
        "attempts": 0,
        "arriveTime": "2019-03-25T15:50:50.123Z",
        "announcement": "507f191e810c19729de860ea",
        "shift": "string",
        "serviceTime": 5,
        "realServiceTime": {
          "serviceTime": 120,
          "tasksDeliveredInSameStop": 1,
          "confidence": "HIGH"
        },
        "imagePath": "https://api.urbantz.com/pictures/platforms/5c3f511c3b31d35f3fc023fc/",
        "maxTransitTime": 0,
        "timeWindowMargin": 0,
        "stopSequence": 2,
        "date": "2019-03-13T12:34:56.012Z",
        "labels": [
          "frozen"
        ],
        "instructions": "Once inside of the building, follow the corridor on the right and take the elevator",
        "product": "string",
        "metadata": {
          "property1": 23,
          "property2": "Hello World"
        },
        "dimensions": {
          "weight": 200,
          "volume": 0.2
        },
        "timeWindow": {
          "start": "2019-03-13T12:34:56.012Z",
          "stop": "2019-03-13T12:34:56.012Z"
        },
        "timeWindow2": {
          "start": "2019-03-13T12:34:56.012Z",
          "stop": "2019-03-13T12:34:56.012Z"
        },
        "contact": {
          "account": "ACC123456789",
          "name": "Acme Inc.",
          "person": "Paco Jones",
          "phone": "+32 477 99 99 99",
          "email": "something@not-a-real-email.org",
          "extraPhones": [
            "+32 477 99 99 99"
          ],
          "extraEmails": [
            "something@not-a-real-email.org"
          ],
          "language": "fr",
          "buildingInfo": {
            "floor": 5,
            "hasElevator": true,
            "digicode1": "1234A",
            "digicode2": "4321A",
            "hasInterphone": true,
            "interphoneCode": "4524#"
          }
        },
        "location": {
          "building": "A cool building name",
          "number": "251",
          "street": "Avenue Louise",
          "city": "Brussels",
          "zip": "1050",
          "origin": "string",
          "country": "Belgium",
          "location": {
            "geometry": [
              0
            ],
            "type": "Point"
          },
          "address": "19 place de la bourse, 31000 Toulouse",
          "addressLines": [
            "string"
          ],
          "cleanScore": 41,
          "geocodeScore": 98
        },
        "source": {
          "building": "A cool building name",
          "number": "251",
          "street": "Avenue Louise",
          "location": {
            "geometry": [
              0
            ],
            "type": "Point"
          },
          "address": "251 Avenue Louise, 1050 BRUXELLES, BELGIQUE",
          "city": "Brussels",
          "zip": "1050",
          "country": "Belgium",
          "cleanScore": 41,
          "geocodeScore": 98,
          "addressLines": [
            "251 Avenue Louise",
            "1050 Brussels",
            "Belgium"
          ]
        },
        "hasBeenPaid": false,
        "price": 0,
        "driver": "5c98f80a6b3dc61664c05cbb",
        "items": [
          {
            "_id": "507f191e810c19729de860ea",
            "type": "Box",
            "status": "PENDING",
            "name": "Soft Drink 6 pack",
            "description": "Big box with a red mark on the top",
            "barcode": "09876543211234",
            "barcodeEncoding": "CODE128",
            "reference": "09876543211234",
            "quantity": 1,
            "processedQuantity": 1,
            "dimensions": {
              "weight": 200,
              "volume": 0.2
            },
            "damaged": {
              "confirmed": false,
              "pictures": [
                "string"
              ]
            },
            "labels": [
              "frozen"
            ],
            "skills": [
              "speaks_french"
            ],
            "log": [
              {
                "_id": "507f191e810c19729de860ea",
                "when": "2019-03-13T12:34:56.012Z",
                "to": "PENDING",
                "by": "string"
              }
            ],
            "metadata": {
              "property1": 23,
              "property2": "Hello World"
            },
            "conditionalChecklists": [
              {
                "name": "string",
                "questions": [
                  {
                    "question": "string",
                    "tips": "string",
                    "success": 0,
                    "failed": 0
                  }
                ]
              }
            ],
            "group": "string"
          }
        ],
        "requires": {
          "pickup": {
            "dispatcher": {
              "scan": false
            },
            "driver": {
              "signature": false,
              "signatureAndComment": false,
              "scan": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "delivery": {
            "dispatcher": {
              "scan": false
            },
            "driver": {
              "prepCheckList": false,
              "prepScan": false,
              "signature": false,
              "signatureAndComment": false,
              "signatureAndItemConcerns": false,
              "scan": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "service": {
            "driver": {
              "signature": false,
              "signatureAndComment": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "other": {
            "driver": {
              "timer": false
            }
          }
        },
        "execution": {
          "successComment": "string",
          "successPicture": "string",
          "failedReason": {
            "reasonId": "507f191e810c19729de860ea",
            "reason": "string",
            "custom": "string",
            "picture": "string"
          },
          "timer": {
            "timestamps": [
              {
                "type": "start",
                "time": "2019-12-23T12:34:56.123Z"
              }
            ]
          },
          "signature": {
            "data": "string",
            "name": "string"
          },
          "position": {
            "accuracy": 0,
            "altitude": 0,
            "heading": 0,
            "latitude": 50.812345,
            "longitude": 4.312345,
            "speed": 0,
            "timestamp": 1553529404789
          },
          "conditionalChecklistReports": {
            "name": "string",
            "answers": [
              {
                "question": "string",
                "answer": "string"
              }
            ]
          },
          "contactless": {
            "forced": true,
            "reason": "string"
          }
        },
        "log": [
          {
            "_id": "507f191e810c19729de860ea",
            "when": "2019-03-13T12:34:56.012Z",
            "to": "ANNOUNCED",
            "by": "string"
          }
        ],
        "alerts": {
          "driverRefused": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "pendingAcceptance": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "exception": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "outOfTime": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "driverLate": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          }
        },
        "categoriesDetails": [
          [
            {
              "name": "B2B"
            },
            {
              "name": "ENG"
            }
          ]
        ],
        "categories": [
          "B2B"
        ],
        "category": "B2B",
        "assets": {
          "deliver": [
            {
              "assetId": "string",
              "name": "string",
              "price": 0,
              "amount": 0
            }
          ],
          "return": [
            {
              "assetId": "string",
              "name": "string",
              "price": 0,
              "amount": 0
            }
          ]
        },
        "attachments": [
          {
            "_id": "5f9af33b4f8cc32e047d83b2",
            "name": "Delivery Note",
            "url": "/attachments/tasks/5c3c63c23c32c30cb3cc1234c/af6227d6-f915-4924-8873-98da8131df3a.pdf"
          }
        ]
      },
      {
        "createdBy": {
          "firstName": "John",
          "lastName": "Doe",
          "_id": "507f191e810c19729de860ea",
          "id": "507f191e810c19729de860ea",
          "externalId": "string"
        },
        "__v": 0,
        "_id": "string",
        "initialSequence": 0,
        "trackingId": "abcdef-123456-4abc-acbacbfcabcfbcbfbacbfab",
        "extTrackId": "ext-12345",
        "type": "delivery",
        "taskId": "my-task-id",
        "taskReference": "task-ref-001-d",
        "progress": "ANNOUNCED",
        "status": "PREPARED",
        "client": "507f191e810c19729de860ea",
        "hub": "507f191e810c19729de860ea",
        "hubName": "My Warehouse",
        "associatedName": "Lumikko Oyj",
        "associated": "5c3c63c23c32c30cb3cc1234c",
        "dependency": "507f191e810c19729de860ea",
        "hasDependency": "507f191e810c19729de860ea",
        "round": "R01",
        "archived": false,
        "actualTime": {
          "arrive": {
            "when": "2019-03-24T12:34:56.123Z",
            "location": {
              "type": "Point",
              "geometry": [
                0
              ]
            },
            "forced": false,
            "isCorrectAddress": false
          }
        },
        "order": "5c98f80a6b3dc61664c05cbf",
        "paymentType": "CCOD",
        "platform": "5c98f80a6b3dc61664c05cbf",
        "platformName": "Cortedal SYS, Oy",
        "endpoint": "5c3c645e3b37f30b3fc0240f",
        "errorLocation": {
          "addressLines": [
            "string"
          ],
          "cleanScore": 0,
          "geocodeScore": 98,
          "location": {
            "type": "Point",
            "geometry": [
              0
            ]
          }
        },
        "customerCalls": [
          {
            "when": "2019-03-13T12:34:56.012Z",
            "by": "string"
          }
        ],
        "issues": [
          {
            "type": "GEOCODING",
            "code": 0,
            "line": 0,
            "error": "string"
          }
        ],
        "notifications": [
          {
            "notifiationId": "string",
            "sentDate": "2019-12-23T12:34:56.123Z",
            "by": {
              "firstName": "John",
              "lastName": "Doe",
              "email": "john.doe@example.3w",
              "phoneNumber": "32123123123",
              "picture": "/some/folder/image/c1235b6a253cd12d3",
              "reference": {
                "name": "self",
                "value": "john.doe@example.3w"
              },
              "_id": "507f191e810c19729de860ea",
              "id": "507f191e810c19729de860ea",
              "externalId": "string"
            }
          }
        ],
        "notificationSettings": {
          "sms": false,
          "email": false
        },
        "optimizationGroup": "string",
        "optimizationCount": 0,
        "replanned": false,
        "sourceHash": "string",
        "updated": "2019-03-24T12:34:56.123Z",
        "when": "2019-03-24T12:34:56.123Z",
        "targetFlux": "56fe250f1eb3571100bb081c_MORNING_57454b1556950a11005189fa_2017-11-15",
        "skills": [
          "speaks_french"
        ],
        "roundName": "R03",
        "roundColor": "#FFCC0D",
        "products": [
          {
            "productId": "001234",
            "name": "CHEESE",
            "description": "Goat cheese pack, 400gr",
            "type": "food",
            "barcode": "11231212121",
            "quantity": 3,
            "unitPrice": 13.95,
            "isSubstitution": false,
            "quantityRejected": 0,
            "rejectedReason": {
              "_id": "507f191e810c19729de860ea",
              "name": "damaged"
            }
          }
        ],
        "hasRejectedProducts": false,
        "activity": "classic",
        "sequence": 1,
        "id": "5c98f80a6b3dc61664c05cbb",
        "flux": "5c3c63c23c32c30cb3cc1234c",
        "collectedAmount": 10.2,
        "closureDate": "2019-03-25T15:50:50.123Z",
        "by": "5c3c63c23c32c30cb3cc1234c",
        "attempts": 0,
        "arriveTime": "2019-03-25T15:50:50.123Z",
        "announcement": "507f191e810c19729de860ea",
        "shift": "string",
        "serviceTime": 5,
        "realServiceTime": {
          "serviceTime": 120,
          "tasksDeliveredInSameStop": 1,
          "confidence": "HIGH"
        },
        "imagePath": "https://api.urbantz.com/pictures/platforms/5c3f511c3b31d35f3fc023fc/",
        "maxTransitTime": 0,
        "timeWindowMargin": 0,
        "stopSequence": 2,
        "date": "2019-03-13T12:34:56.012Z",
        "labels": [
          "frozen"
        ],
        "instructions": "Once inside of the building, follow the corridor on the right and take the elevator",
        "product": "string",
        "metadata": {
          "property1": 23,
          "property2": "Hello World"
        },
        "dimensions": {
          "weight": 200,
          "volume": 0.2
        },
        "timeWindow": {
          "start": "2019-03-13T12:34:56.012Z",
          "stop": "2019-03-13T12:34:56.012Z"
        },
        "timeWindow2": {
          "start": "2019-03-13T12:34:56.012Z",
          "stop": "2019-03-13T12:34:56.012Z"
        },
        "contact": {
          "account": "ACC123456789",
          "name": "Acme Inc.",
          "person": "Paco Jones",
          "phone": "+32 477 99 99 99",
          "email": "something@not-a-real-email.org",
          "extraPhones": [
            "+32 477 99 99 99"
          ],
          "extraEmails": [
            "something@not-a-real-email.org"
          ],
          "language": "fr",
          "buildingInfo": {
            "floor": 5,
            "hasElevator": true,
            "digicode1": "1234A",
            "digicode2": "4321A",
            "hasInterphone": true,
            "interphoneCode": "4524#"
          }
        },
        "location": {
          "building": "A cool building name",
          "number": "251",
          "street": "Avenue Louise",
          "city": "Brussels",
          "zip": "1050",
          "origin": "string",
          "country": "Belgium",
          "location": {
            "geometry": [
              0
            ],
            "type": "Point"
          },
          "address": "19 place de la bourse, 31000 Toulouse",
          "addressLines": [
            "string"
          ],
          "cleanScore": 41,
          "geocodeScore": 98
        },
        "source": {
          "building": "A cool building name",
          "number": "251",
          "street": "Avenue Louise",
          "location": {
            "geometry": [
              0
            ],
            "type": "Point"
          },
          "address": "251 Avenue Louise, 1050 BRUXELLES, BELGIQUE",
          "city": "Brussels",
          "zip": "1050",
          "country": "Belgium",
          "cleanScore": 41,
          "geocodeScore": 98,
          "addressLines": [
            "251 Avenue Louise",
            "1050 Brussels",
            "Belgium"
          ]
        },
        "hasBeenPaid": false,
        "price": 0,
        "driver": "5c98f80a6b3dc61664c05cbb",
        "items": [
          {
            "_id": "507f191e810c19729de860ea",
            "type": "Box",
            "status": "PENDING",
            "name": "Soft Drink 6 pack",
            "description": "Big box with a red mark on the top",
            "barcode": "09876543211234",
            "barcodeEncoding": "CODE128",
            "reference": "09876543211234",
            "quantity": 1,
            "processedQuantity": 1,
            "dimensions": {
              "weight": 200,
              "volume": 0.2
            },
            "damaged": {
              "confirmed": false,
              "pictures": [
                "string"
              ]
            },
            "labels": [
              "frozen"
            ],
            "skills": [
              "speaks_french"
            ],
            "log": [
              {
                "_id": "507f191e810c19729de860ea",
                "when": "2019-03-13T12:34:56.012Z",
                "to": "PENDING",
                "by": "string"
              }
            ],
            "metadata": {
              "property1": 23,
              "property2": "Hello World"
            },
            "conditionalChecklists": [
              {
                "name": "string",
                "questions": [
                  {
                    "question": "string",
                    "tips": "string",
                    "success": 0,
                    "failed": 0
                  }
                ]
              }
            ],
            "group": "string"
          }
        ],
        "requires": {
          "pickup": {
            "dispatcher": {
              "scan": false
            },
            "driver": {
              "signature": false,
              "signatureAndComment": false,
              "scan": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "delivery": {
            "dispatcher": {
              "scan": false
            },
            "driver": {
              "prepCheckList": false,
              "prepScan": false,
              "signature": false,
              "signatureAndComment": false,
              "signatureAndItemConcerns": false,
              "scan": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "service": {
            "driver": {
              "signature": false,
              "signatureAndComment": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "other": {
            "driver": {
              "timer": false
            }
          }
        },
        "execution": {
          "successComment": "string",
          "successPicture": "string",
          "failedReason": {
            "reasonId": "507f191e810c19729de860ea",
            "reason": "string",
            "custom": "string",
            "picture": "string"
          },
          "timer": {
            "timestamps": [
              {
                "type": "start",
                "time": "2019-12-23T12:34:56.123Z"
              }
            ]
          },
          "signature": {
            "data": "string",
            "name": "string"
          },
          "position": {
            "accuracy": 0,
            "altitude": 0,
            "heading": 0,
            "latitude": 50.812345,
            "longitude": 4.312345,
            "speed": 0,
            "timestamp": 1553529404789
          },
          "conditionalChecklistReports": {
            "name": "string",
            "answers": [
              {
                "question": "string",
                "answer": "string"
              }
            ]
          },
          "contactless": {
            "forced": true,
            "reason": "string"
          }
        },
        "log": [
          {
            "_id": "507f191e810c19729de860ea",
            "when": "2019-03-13T12:34:56.012Z",
            "to": "ANNOUNCED",
            "by": "string"
          }
        ],
        "alerts": {
          "driverRefused": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "pendingAcceptance": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "exception": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "outOfTime": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "driverLate": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          }
        },
        "categoriesDetails": [
          [
            {
              "name": "B2B"
            },
            {
              "name": "ENG"
            }
          ]
        ],
        "categories": [
          "B2B"
        ],
        "category": "B2B",
        "assets": {
          "deliver": [
            {
              "assetId": "string",
              "name": "string",
              "price": 0,
              "amount": 0
            }
          ],
          "return": [
            {
              "assetId": "string",
              "name": "string",
              "price": 0,
              "amount": 0
            }
          ]
        },
        "attachments": [
          {
            "_id": "5f9af33b4f8cc32e047d83b2",
            "name": "Delivery Note",
            "url": "/attachments/tasks/5c3c63c23c32c30cb3cc1234c/af6227d6-f915-4924-8873-98da8131df3a.pdf"
          }
        ]
      },
      {
        "createdBy": {
          "firstName": "John",
          "lastName": "Doe",
          "_id": "507f191e810c19729de860ea",
          "id": "507f191e810c19729de860ea",
          "externalId": "string"
        },
        "__v": 0,
        "_id": "string",
        "initialSequence": 0,
        "trackingId": "abcdef-123456-4abc-acbacbfcabcfbcbfbacbfab",
        "extTrackId": "ext-12345",
        "type": "delivery",
        "taskId": "my-task-id",
        "taskReference": "task-ref-001-d",
        "progress": "ANNOUNCED",
        "status": "PICKED_UP",
        "client": "507f191e810c19729de860ea",
        "hub": "507f191e810c19729de860ea",
        "hubName": "My Warehouse",
        "associatedName": "Lumikko Oyj",
        "associated": "5c3c63c23c32c30cb3cc1234c",
        "dependency": "507f191e810c19729de860ea",
        "hasDependency": "507f191e810c19729de860ea",
        "round": "R01",
        "archived": false,
        "actualTime": {
          "arrive": {
            "when": "2019-03-24T12:34:56.123Z",
            "location": {
              "type": "Point",
              "geometry": [
                0
              ]
            },
            "forced": false,
            "isCorrectAddress": false
          }
        },
        "order": "5c98f80a6b3dc61664c05cbf",
        "paymentType": "CCOD",
        "platform": "5c98f80a6b3dc61664c05cbf",
        "platformName": "Cortedal SYS, Oy",
        "endpoint": "5c3c645e3b37f30b3fc0240f",
        "errorLocation": {
          "addressLines": [
            "string"
          ],
          "cleanScore": 0,
          "geocodeScore": 98,
          "location": {
            "type": "Point",
            "geometry": [
              0
            ]
          }
        },
        "customerCalls": [
          {
            "when": "2019-03-13T12:34:56.012Z",
            "by": "string"
          }
        ],
        "issues": [
          {
            "type": "GEOCODING",
            "code": 0,
            "line": 0,
            "error": "string"
          }
        ],
        "notifications": [
          {
            "notifiationId": "string",
            "sentDate": "2019-12-23T12:34:56.123Z",
            "by": {
              "firstName": "John",
              "lastName": "Doe",
              "email": "john.doe@example.3w",
              "phoneNumber": "32123123123",
              "picture": "/some/folder/image/c1235b6a253cd12d3",
              "reference": {
                "name": "self",
                "value": "john.doe@example.3w"
              },
              "_id": "507f191e810c19729de860ea",
              "id": "507f191e810c19729de860ea",
              "externalId": "string"
            }
          }
        ],
        "notificationSettings": {
          "sms": false,
          "email": false
        },
        "optimizationGroup": "string",
        "optimizationCount": 0,
        "replanned": false,
        "sourceHash": "string",
        "updated": "2019-03-24T12:34:56.123Z",
        "when": "2019-03-24T12:34:56.123Z",
        "targetFlux": "56fe250f1eb3571100bb081c_MORNING_57454b1556950a11005189fa_2017-11-15",
        "skills": [
          "speaks_french"
        ],
        "roundName": "R03",
        "roundColor": "#FFCC0D",
        "products": [
          {
            "productId": "001234",
            "name": "CHEESE",
            "description": "Goat cheese pack, 400gr",
            "type": "food",
            "barcode": "11231212121",
            "quantity": 3,
            "unitPrice": 13.95,
            "isSubstitution": false,
            "quantityRejected": 0,
            "rejectedReason": {
              "_id": "507f191e810c19729de860ea",
              "name": "damaged"
            }
          }
        ],
        "hasRejectedProducts": false,
        "activity": "classic",
        "sequence": 1,
        "id": "5c98f80a6b3dc61664c05cbb",
        "flux": "5c3c63c23c32c30cb3cc1234c",
        "collectedAmount": 10.2,
        "closureDate": "2019-03-25T15:50:50.123Z",
        "by": "5c3c63c23c32c30cb3cc1234c",
        "attempts": 0,
        "arriveTime": "2019-03-25T15:50:50.123Z",
        "announcement": "507f191e810c19729de860ea",
        "shift": "string",
        "serviceTime": 5,
        "realServiceTime": {
          "serviceTime": 120,
          "tasksDeliveredInSameStop": 1,
          "confidence": "HIGH"
        },
        "imagePath": "https://api.urbantz.com/pictures/platforms/5c3f511c3b31d35f3fc023fc/",
        "maxTransitTime": 0,
        "timeWindowMargin": 0,
        "stopSequence": 2,
        "date": "2019-03-13T12:34:56.012Z",
        "labels": [
          "frozen"
        ],
        "instructions": "Once inside of the building, follow the corridor on the right and take the elevator",
        "product": "string",
        "metadata": {
          "property1": 23,
          "property2": "Hello World"
        },
        "dimensions": {
          "weight": 200,
          "volume": 0.2
        },
        "timeWindow": {
          "start": "2019-03-13T14:34:56.012Z",
          "stop": "2019-03-13T14:34:56.012Z"
        },
        "timeWindow2": {
          "start": "2019-03-13T12:34:56.012Z",
          "stop": "2019-03-13T12:34:56.012Z"
        },
        "contact": {
          "account": "ACC123456789",
          "name": "Acme Inc.",
          "person": "Paco Jones",
          "phone": "+32 477 99 99 99",
          "email": "something@not-a-real-email.org",
          "extraPhones": [
            "+32 477 99 99 99"
          ],
          "extraEmails": [
            "something@not-a-real-email.org"
          ],
          "language": "fr",
          "buildingInfo": {
            "floor": 5,
            "hasElevator": true,
            "digicode1": "1234A",
            "digicode2": "4321A",
            "hasInterphone": true,
            "interphoneCode": "4524#"
          }
        },
        "location": {
          "building": "A cool building name",
          "number": "251",
          "street": "Avenue Louise",
          "city": "Brussels",
          "zip": "1050",
          "origin": "string",
          "country": "Belgium",
          "location": {
            "geometry": [
              0
            ],
            "type": "Point"
          },
          "address": "20 rue emile caffort, 31200 Toulouse",
          "addressLines": [
            "string"
          ],
          "cleanScore": 41,
          "geocodeScore": 98
        },
        "source": {
          "building": "A cool building name",
          "number": "251",
          "street": "Avenue Louise",
          "location": {
            "geometry": [
              0
            ],
            "type": "Point"
          },
          "address": "251 Avenue Louise, 1050 BRUXELLES, BELGIQUE",
          "city": "Brussels",
          "zip": "1050",
          "country": "Belgium",
          "cleanScore": 41,
          "geocodeScore": 98,
          "addressLines": [
            "251 Avenue Louise",
            "1050 Brussels",
            "Belgium"
          ]
        },
        "hasBeenPaid": false,
        "price": 0,
        "driver": "5c98f80a6b3dc61664c05cbb",
        "items": [
          {
            "_id": "507f191e810c19729de860ea",
            "type": "Box",
            "status": "PENDING",
            "name": "Soft Drink 6 pack",
            "description": "Big box with a red mark on the top",
            "barcode": "09876543211234",
            "barcodeEncoding": "CODE128",
            "reference": "09876543211234",
            "quantity": 1,
            "processedQuantity": 1,
            "dimensions": {
              "weight": 200,
              "volume": 0.2
            },
            "damaged": {
              "confirmed": false,
              "pictures": [
                "string"
              ]
            },
            "labels": [
              "frozen"
            ],
            "skills": [
              "speaks_french"
            ],
            "log": [
              {
                "_id": "507f191e810c19729de860ea",
                "when": "2019-03-13T12:34:56.012Z",
                "to": "PENDING",
                "by": "string"
              }
            ],
            "metadata": {
              "property1": 23,
              "property2": "Hello World"
            },
            "conditionalChecklists": [
              {
                "name": "string",
                "questions": [
                  {
                    "question": "string",
                    "tips": "string",
                    "success": 0,
                    "failed": 0
                  }
                ]
              }
            ],
            "group": "string"
          }
        ],
        "requires": {
          "pickup": {
            "dispatcher": {
              "scan": false
            },
            "driver": {
              "signature": false,
              "signatureAndComment": false,
              "scan": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "delivery": {
            "dispatcher": {
              "scan": false
            },
            "driver": {
              "prepCheckList": false,
              "prepScan": false,
              "signature": false,
              "signatureAndComment": false,
              "signatureAndItemConcerns": false,
              "scan": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "service": {
            "driver": {
              "signature": false,
              "signatureAndComment": false,
              "comment": false,
              "photo": false
            },
            "stop": {
              "onSite": false
            },
            "failure": {
              "photo": false
            }
          },
          "other": {
            "driver": {
              "timer": false
            }
          }
        },
        "execution": {
          "successComment": "string",
          "successPicture": "string",
          "failedReason": {
            "reasonId": "507f191e810c19729de860ea",
            "reason": "string",
            "custom": "string",
            "picture": "string"
          },
          "timer": {
            "timestamps": [
              {
                "type": "start",
                "time": "2019-12-23T12:34:56.123Z"
              }
            ]
          },
          "signature": {
            "data": "string",
            "name": "string"
          },
          "position": {
            "accuracy": 0,
            "altitude": 0,
            "heading": 0,
            "latitude": 50.812345,
            "longitude": 4.312345,
            "speed": 0,
            "timestamp": 1553529404789
          },
          "conditionalChecklistReports": {
            "name": "string",
            "answers": [
              {
                "question": "string",
                "answer": "string"
              }
            ]
          },
          "contactless": {
            "forced": true,
            "reason": "string"
          }
        },
        "log": [
          {
            "_id": "507f191e810c19729de860ea",
            "when": "2019-03-13T12:34:56.012Z",
            "to": "ANNOUNCED",
            "by": "string"
          }
        ],
        "alerts": {
          "driverRefused": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "pendingAcceptance": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "exception": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "outOfTime": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          },
          "driverLate": {
            "when": "2019-03-13T12:34:56.012Z",
            "solved": "2019-03-13T12:34:56.012Z",
            "data": {}
          }
        },
        "categoriesDetails": [
          [
            {
              "name": "B2B"
            },
            {
              "name": "ENG"
            }
          ]
        ],
        "categories": [
          "B2B"
        ],
        "category": "B2B",
        "assets": {
          "deliver": [
            {
              "assetId": "string",
              "name": "string",
              "price": 0,
              "amount": 0
            }
          ],
          "return": [
            {
              "assetId": "string",
              "name": "string",
              "price": 0,
              "amount": 0
            }
          ]
        },
        "attachments": [
          {
            "_id": "5f9af33b4f8cc32e047d83b2",
            "name": "Delivery Note",
            "url": "/attachments/tasks/5c3c63c23c32c30cb3cc1234c/af6227d6-f915-4924-8873-98da8131df3a.pdf"
          }
        ]
      }
    ]

    UpdateTask = {
      "taskId": "my-task-id",
      "taskReference": "task-ref-001-d",
      "paymentType": "CCOD",
      "skills": [
        "speaks_french"
      ],
      "products": [
        {
          "productId": "001234",
          "name": "CHEESE",
          "description": "Goat cheese pack, 400gr",
          "type": "food",
          "barcode": "11231212121",
          "quantity": 3,
          "unitPrice": 13.95,
          "isSubstitution": false,
          "quantityRejected": 0,
          "rejectedReason": {
            "_id": "507f191e810c19729de860ea",
            "name": "damaged"
          }
        }
      ],
      "activity": "classic",
      "sequence": 1,
      "collectedAmount": 0,
      "serviceTime": 5,
      "maxTransitTime": 0,
      "timeWindowMargin": 0,
      "labels": [
        "frozen"
      ],
      "instructions": "Once inside of the building, follow the corridor on the right and take the elevator",
      "product": "string",
      "metadata": {
        "property1": 23,
        "property2": "Hello World"
      },
      "dimensions": {
        "weight": 200,
        "volume": 0.2
      },
      "timeWindow": {
        "start": "2019-03-13T12:34:56.012Z",
        "stop": "2019-03-13T12:34:56.012Z"
      },
      "timeWindow2": {
        "start": "2019-03-13T12:34:56.012Z",
        "stop": "2019-03-13T12:34:56.012Z"
      },
      "contact": {
        "account": "ACC123456789",
        "name": "Acme Inc.",
        "person": "Paco Jones",
        "phone": "+32 477 99 99 99",
        "email": "something@not-a-real-email.org",
        "extraPhones": [
          "+32 477 99 99 99"
        ],
        "extraEmails": [
          "something@not-a-real-email.org"
        ],
        "language": "fr",
        "buildingInfo": {
          "floor": 5,
          "hasElevator": true,
          "digicode1": "1234A",
          "digicode2": "4321A",
          "hasInterphone": true,
          "interphoneCode": "4524#"
        }
      },
      "location": {
        "building": "A cool building name",
        "number": "251",
        "street": "Avenue Louise",
        "city": "Brussels",
        "zip": "1050",
        "origin": "string",
        "country": "Belgium",
        "location": {
          "geometry": [
            0
          ],
          "type": "Point"
        },
        "address": "251 avenue louise, 1050 Brussels, Belgium",
        "addressLines": [
          "string"
        ],
        "cleanScore": 41,
        "geocodeScore": 98
      },
      "address": {
        "building": "A cool building name",
        "number": "251",
        "street": "Avenue Louise",
        "location": {
          "geometry": [
            0
          ],
          "type": "Point"
        },
        "address": "251 Avenue Louise, 1050 BRUXELLES, BELGIQUE",
        "city": "Brussels",
        "zip": "1050",
        "country": "Belgium",
        "cleanScore": 41,
        "geocodeScore": 98,
        "addressLines": [
          "251 Avenue Louise",
          "1050 Brussels",
          "Belgium"
        ]
      },
      "hasBeenPaid": false,
      "price": 0,
      "items": [
        {
          "_id": "507f191e810c19729de860ea",
          "type": "Box",
          "status": "PENDING",
          "name": "Soft Drink 6 pack",
          "description": "Big box with a red mark on the top",
          "barcode": "09876543211234",
          "barcodeEncoding": "CODE128",
          "reference": "09876543211234",
          "quantity": 1,
          "processedQuantity": 1,
          "dimensions": {
            "weight": 200,
            "volume": 0.2
          },
          "damaged": {
            "confirmed": false,
            "pictures": [
              "string"
            ]
          },
          "labels": [
            "frozen"
          ],
          "skills": [
            "speaks_french"
          ],
          "log": [
            {
              "_id": "507f191e810c19729de860ea",
              "when": "2019-03-13T12:34:56.012Z",
              "to": "PENDING",
              "by": "string"
            }
          ],
          "metadata": {
            "property1": 23,
            "property2": "Hello World"
          },
          "conditionalChecklists": [
            {
              "name": "string",
              "questions": [
                {
                  "question": "string",
                  "tips": "string",
                  "success": 0,
                  "failed": 0
                }
              ]
            }
          ],
          "group": "string"
        }
      ],
      "requires": {
        "pickup": {
          "dispatcher": {
            "scan": false
          },
          "driver": {
            "signature": false,
            "signatureAndComment": false,
            "scan": false,
            "comment": false,
            "photo": false
          },
          "stop": {
            "onSite": false
          },
          "failure": {
            "photo": false
          }
        },
        "delivery": {
          "dispatcher": {
            "scan": false
          },
          "driver": {
            "prepCheckList": false,
            "prepScan": false,
            "signature": false,
            "signatureAndComment": false,
            "signatureAndItemConcerns": false,
            "scan": false,
            "comment": false,
            "photo": false
          },
          "stop": {
            "onSite": false
          },
          "failure": {
            "photo": false
          }
        },
        "service": {
          "driver": {
            "signature": false,
            "signatureAndComment": false,
            "comment": false,
            "photo": false
          },
          "stop": {
            "onSite": false
          },
          "failure": {
            "photo": false
          }
        },
        "other": {
          "driver": {
            "timer": false
          }
        }
      },
      "execution": {
        "successComment": "string",
        "successPicture": "string",
        "failedReason": {
          "reasonId": "507f191e810c19729de860ea",
          "reason": "string",
          "custom": "string",
          "picture": "string"
        },
        "timer": {
          "timestamps": [
            {
              "type": "start",
              "time": "2019-12-23T12:34:56.123Z"
            }
          ]
        },
        "signature": {
          "data": "string",
          "name": "string"
        },
        "position": {
          "accuracy": 0,
          "altitude": 0,
          "heading": 0,
          "latitude": 50.812345,
          "longitude": 4.312345,
          "speed": 0,
          "timestamp": 1553529404789
        },
        "conditionalChecklistReports": {
          "name": "string",
          "answers": [
            {
              "question": "string",
              "answer": "string"
            }
          ]
        },
        "contactless": {
          "forced": true,
          "reason": "string"
        }
      },
      "categoriesDetails": [
        [
          {
            "name": "B2B"
          },
          {
            "name": "ENG"
          }
        ]
      ],
      "category": "B2B",
      "notificationSettings": {
        "sms": false,
        "email": false
      },
      "collect": {
        "activated": true,
        "point": "point1",
        "timeWindow": {
          "start": "2019-03-13T12:34:56.012Z",
          "stop": "2019-03-13T12:34:56.012Z"
        }
      },
      "returnedProducts": [
        {
          "_id": "507f191e810c19729de860ea",
          "barcode": "5410078235370",
          "description": "Soft",
          "name": "Coca Cola zero SG 20clx24",
          "productId": "001234",
          "type": "Food",
          "unitPrice": 13.95,
          "quantity": 3
        }
      ],
      "priority": 0
    }

    Livraisons = [{
        firstname:"Babakar",
        lastname:"WADE",
        username:"babakar.wade.31@gmail.com",
        phone:"0660347616",
        Adresse_Select:"49bld Des Minimes, 31000 Toulouse",
        com_adr:"4ème étage",
        setpoids:10,
        Jour_Livraison:"05-03-2022",
        Heure_Drive:"15h à 16h",
        id_commande : 1,
        shopname: "barrière",
        coordonnee: {
          lat:43.6047863,
          lng:1.4270773
        },
        suivi:{
          preparation:{
            value:true,
          },
          collect:{
            value:false,
          },
          transport:{
            value:false,
          },
          livraison:{
            value:false,
          },
        }
      },{
        firstname:"Cyrille",
        lastname:"AUZOU",
        username:"Cyrille.AUZOU@gmail.com",
        phone:"0768335546",
        Adresse_Select:"3 Av. Paul Séjourné, 31300 Toulouse",
        com_adr:"",
        setpoids:10,
        Jour_Livraison:"06-03-2022",
        Heure_Drive:"15h à 16h",
        id_commande : 1,
        shopname: "barrière",
        coordonnee: {
          lat:43.605716,
          lng:1.435205
        },
        suivi:{
          preparation:{
            value:true,
          },
          collect:{
            value:false,
          },
          transport:{
            value:false,
          },
          livraison:{
            value:false,
          },
        }
      },{
        firstname:"Matthieu",
        lastname:"ABEYDE",
        username:"babakar.wade.31@gmail.com",
        phone:"0660347616",
        Adresse_Select:"19 place de la bourse, 31200 Toulouse",
        com_adr:"4ème étage",
        setpoids:10,
        Jour_Livraison:"05-03-2022",
        Heure_Drive:"15h à 16h",
        id_commande : 1,
        shopname: "barrière",
        coordonnee: {
          lat:43.599625,
          lng:1.434089
        },
        suivi:{
          preparation:{
            value:true,
          },
          collect:{
            value:true,
          },
          transport:{
            value:false,
          },
          livraison:{
            value:false,
          },
        }
      },{
        firstname:"Matthieu",
        lastname:"ABEYDE",
        username:"babakar.wade.31@gmail.com",
        phone:"0660347616",
        Adresse_Select:"19 place de la bourse, 31200 Toulouse",
        com_adr:"4ème étage",
        setpoids:10,
        Jour_Livraison:"05-03-2022",
        Heure_Drive:"15h à 16h",
        id_commande : 1,
        shopname: "barrière",
        coordonnee: {
          lat:43.609476,
          lng:1.450064
        },
        suivi:{
          preparation:{
            value:true,
          },
          collect:{
            value:true,
          },
          transport:{
            value:false,
          },
          livraison:{
            value:false,
          },
        }
      },{
        firstname:"Matthieu",
        lastname:"ABEYDE",
        username:"babakar.wade.31@gmail.com",
        phone:"0660347616",
        Adresse_Select:"19 place de la bourse, 31200 Toulouse",
        com_adr:"4ème étage",
        setpoids:10,
        Jour_Livraison:"05-03-2022",
        Heure_Drive:"15h à 16h",
        id_commande : 1,
        shopname: "barrière",
        coordonnee: {
          lat:43.596610,
          lng:1.449978
        },
        suivi:{
          preparation:{
            value:true,
          },
          collect:{
            value:true,
          },
          transport:{
            value:false,
          },
          livraison:{
            value:false,
          },
        }
      }];

    // Firebase Analytics
    // firebaseConfig = {
    //     apiKey: "AIzaSyCSNVbICRwcFP2HFu7dqGJoW5tr9IqtNTU",
    //     authDomain: "kotionic.firebaseapp.com",
    //     projectId: "kotionic",
    //     storageBucket: "kotionic.appspot.com",
    //     messagingSenderId: "1034641841684",
    //     appId: "1:1034641841684:web:493d6d97f468924b5a1101", 
    //     measurementId: "G-G6QR4Q6LG5"
    // };


    // // Tracking 
    // AnalyticsProvider = false;

}




// WEBPACK FOOTER //
// ./src/app/configuration.ts